<template>
  <Toaster v-if="message.value" :message="message" @close="resetMessage" />
</template>

<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Config from '@/config';
import Toaster from '@/components/common/Notification/Toaster.vue';
import { useService } from '@/composables';

// Define component name
defineOptions({
  name: 'systemNotification'
});

// Composables
const { t } = useI18n();
const { systemMessage, systemMessageTimeout } = useService();

// Reactive data
const options = ref({
  timeout: Config.SYSTEM_MESSAGE.LIFE_SPAN
});
const message = ref({});

// Methods
const translatedMessage = () => {
  message.value = Object.assign({}, systemMessage.value);
  message.value.value = t(systemMessage.value.value);
  message.value.timeout = systemMessageTimeout.value;
};

const resetMessage = () => {
  message.value = {};
};

// Watchers
watch(systemMessage, () => {
  translatedMessage();
});
</script>